<template>
  <div class="kangxin">
    <div class="kv">
      <img src="@/assets/family/anxin/anxinkv.png" alt="">
    </div>
    <HuaXing v-if="colorList.length > 0" :info="colorList" @next="next" :isloading="isloading" :showBtn="showBtn"></HuaXing>
    <div class="container">
      <img class="image" src="../../../assets/family/anxin/0.png" alt="">
    </div>
    <!-- <div class="animation-section">
      <img class="img1 wow" data-wow-duration="2s" src="../../../assets/family/anxin/animate1.png" alt="">
      <img class="img2 wow" data-wow-duration="2s" src="../../../assets/family/anxin/animate2.png" alt="">
    </div>
    <img class="image" src="@/assets/family/anxin/anxin2.png" alt=""> -->
  </div>
</template>

<script>
import { getGrainList } from '@/api/product'
import huaxing from '@/components/huaxing.vue'
import WOW from '../../../../node_modules/wowjs/dist/wow';
export default {
  name: 'Kangxin',
  components: {
    HuaXing: huaxing
  },
  data() {
    return {
      isloading: false, // 加载中
      showBtn: true, // 更多
      form: {
        product_id: 2 ,
        pageNum: 1,
        pageSize: 8
      },
      colorList: []
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 180,
      mobile: true,
      live: true
    });
    wow.init();
  },
  methods: {
    getList() {
      this.isloading = true
      getGrainList({
        ...this.form
      }).then(res => {
        if (res.dataList && res.dataList.length > 0) {
          res.dataList.forEach(item => {
            item.mp_logo_pic ? item.mp_logo_pic = JSON.parse(item.mp_logo_pic) : []
          })
          this.colorList = [...this.colorList, ...res.dataList]
          if (res.dataList.length >= this.form.pageSize) {
            this.showBtn = true
          } else {
            this.showBtn = false
          }
        } else {
          this.showBtn = false
        }
        this.isloading = false
      })
    },
    next() {
      if (this.isloading) return
      this.form.pageNum++
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.kangxin {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  .kv {
    width: 100%;
    max-width: 1920px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .image {
    width: 100%;
    vertical-align: middle;
  }
  .animation-section {
    width: 100%;
    height: 1148px;
    position: relative;
    .img1 {
      width: 1723px;
      height: 1148px;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -861.5px;
      z-index: 2;
      animation: first-left 1s forwards;
      opacity: 0;
    }
    .img2 {
      width: 1068px;
      height: 655px;
      position: absolute;
      top: 181.5px;
      left: 84.5px;
      z-index: 3;
      animation: first-left 0.5s forwards;
      animation-delay: 1s;
      opacity: 0;
    }
    @keyframes first-left {
      0% {
        transform: translateX(100px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
  .container {
		max-width: 1920px;
		margin: 0 auto;
		padding: 60px 220px;
		.image {
			width: 100%;
			vertical-align: top;
			display: block;
		}
	}
}
</style>
